import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { AngularFireList, AngularFireDatabase } from '@angular/fire/database';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { tipoGlobalInfo } from '../models/usuario.model';


@Injectable({
    providedIn: 'root',
})
export class datalocalService {

    public jugadoresDB: AngularFireList<tipoGlobalInfo>;

    private greatUrl = 'https://sesiones-live-red-default-rtdb.firebaseio.com/webinars/gralinfo';

    globalinfo: tipoGlobalInfo = {};
    accesada = false;

    constructor(
        private http: HttpClient,
        private db: AngularFireDatabase
    ) {

        this.jugadoresDB = this.db.list('/liveinfo', (ref) =>
            ref.orderByChild('grales')
        );
        

        this.http.get('assets/data/localdata.json')
            .subscribe((resp: tipoGlobalInfo) => {

                this.accesada = true;
                this.globalinfo = resp;

                console.log(resp['localconexion']);

            });
    }


    //Devuelve un Observable de tipo Jugador Array.
    getJugadores(): Observable<tipoGlobalInfo[]> {
        //? this.jugadoresDB ya tiene la base de datos.
        //? snapshotChanges obtiene la informacion en este momento.
        //? Obtiene los datos junto con la Key
        //? Con Pipe permite hacer modificaciones
        //? Con Map haremos un cambio, que por cada uno de los jugadores retornaremos la informacion,
        //? y se Agregue una Key.
        //? El formato de key siempre es $key.
        //? Payload es por donde esta viajando la data.
        return this.jugadoresDB.snapshotChanges().pipe(
            //?A veces hay que importar map manualmente de rsjs/operators
            map((changes) => {
                return changes.map((c) => ({
                    $key: c.payload.key,
                    ...c.payload.val(),
                }));
            })
        );
    }

    //Metodo para crear un nuevo jugador en la DB
    addJugador(jugador: tipoGlobalInfo) {
        //?Con esto FireBase se encarga de todo,
        //?no hay que pensar en endpoints o si esta o no creada la tabla.
        //?Adicionamos un nuevo record a la tabla.
        return this.jugadoresDB.push(jugador);
    }

    //Borrar un Jugador de la DB
    deleteJugador(id: string) {
        //? Que base de datos afectaremos? Jugadores.
        //? El id del jugador que deseamos eliminar.
        this.db.list('/webinars').remove(id);
    }

    //Editar un Jugador
    editJugador(newJugadorData) {
        //? Salvamos el Key.
        //? Eliminamos el registro anterior con el Key.
        //? Nuevamente asignamos a ese registro la nueva información en la base de datos.
        //? FireBase no acepta que ya se contenga una Key, por eso se hizo la Key opcional.
        //? Al borrar o actualizar daria problema sino fuera opcional.
        const $key = newJugadorData.$key;
        delete newJugadorData.$key;
        this.db.list('/webinars').update($key, newJugadorData);
    }

}
